module.exports = __webpack_public_path__ + "media/src/images/course-page-card_small-b288d9e2bce4602a5c80017ca4e99d42.png";